// extracted by mini-css-extract-plugin
export var menuIcon = "_rt-0";
export var menuIconInline = "_rt-1";